// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { z } from 'zod';

export const locationCompanyTypeSchema = z.enum(['customer', 'manufacturer']);

export type LocationCompanyType = z.infer<typeof locationCompanyTypeSchema>;
